// extracted by css-extract-rspack-plugin
export default {"commaSpan":"Z89OST7ENrgzrsZe","orText":"ain86eQcUd4T44mB"};